var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAddCircle = function SvgAddCircle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 124 124",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.433 62.127c0 31.7-25.697 57.396-57.396 57.396-31.7 0-57.396-25.697-57.396-57.396S30.338 4.731 62.037 4.731s57.396 25.697 57.396 57.396Z",
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.037 36.48a4.398 4.398 0 0 0-4.397 4.397v17.086H40.554a4.397 4.397 0 1 0 0 8.794H57.64v17.086a4.397 4.397 0 1 0 8.794 0V66.757H83.52a4.398 4.398 0 0 0 0-8.794H66.434V40.877a4.397 4.397 0 0 0-4.397-4.397",
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAddCircle);
export default ForwardRef;